import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';


import { AppComponent } from './app.component';
import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { HttpClientModule } from '@angular/common/http';

import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';
import { ProfileComponent } from './profile/profile.component';
import { HttpService } from './http/http.service';
import { SigninService } from './signin/signin.service';
import { SigninServiceImpl } from './signin/signin.service.impl';
import { SsoServiceImpl } from './sso/sso.service.impl';
import { SsoService } from './sso/sso.service';
import { ProfileServiceImpl } from './profile/profile.service.impl';
import { ProfileService } from './profile/profile.service';
import { DatePipe } from '@angular/common';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { ForgotPasswordServiceImpl } from './forgotpassword/forgotpassword.service.impl';
import { ForgotPasswordService } from './forgotpassword/forgotpassword.service';

const appRoutes: Routes = [
  { path: 'profile', component: ProfileComponent },
  { path: 'signin', component: SigninComponent },
  { path: 'resetPassword', component: ForgotpasswordComponent },
  { path: '', redirectTo: '/signin', pathMatch: 'full' }
];

@NgModule({
  declarations: [
    AppComponent,
    SigninComponent,
    SignupComponent,
    ProfileComponent,
    ForgotpasswordComponent
  ],
  imports: [
    RouterModule.forRoot(appRoutes),
    BrowserModule,
    HttpModule,
    HttpClientModule,
    ReactiveFormsModule
  ],
  providers: [
    DatePipe ,
    { provide: SigninService, useClass: SigninServiceImpl },
    { provide: SsoService, useClass: SsoServiceImpl },
    { provide: ProfileService, useClass: ProfileServiceImpl },
    { provide: ForgotPasswordService, useClass: ForgotPasswordServiceImpl },
    HttpService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts